<template>
  <div>
    <h3 class="font-weight-bold">{{ Summery.title }}</h3>
    <hr class="mb-5" />
    <b-card-group deck>
      <b-card class="custom-card">
        <div class="d-flex">
          <div class="flex-fill">
            <h1 class="font-weight-bold">{{ Summery.school }}</h1>
            <p>انجمن</p>
          </div>
          <i
            class="icon-Home-5 text-primary my-auto"
            style="font-size: 60px"
          ></i>
        </div>
      </b-card>
      <b-card class="custom-card">
        <div class="d-flex">
          <div class="flex-fill">
            <h1 class="font-weight-bold">{{ Summery.student }}</h1>
            <p>اعضای اصلی</p>
          </div>
          <i class="icon-Male text-primary my-auto" style="font-size: 60px"></i>
        </div>
      </b-card>
      <b-card class="custom-card">
        <div class="d-flex">
          <div class="flex-fill">
            <h1 class="font-weight-bold">{{ Summery.adviser }}</h1>
            <p>مربی متصل</p>
          </div>
          <i
            class="icon-Student-Male text-primary my-auto"
            style="font-size: 60px"
          ></i>
        </div>
      </b-card>
      <b-card class="custom-card">
        <div class="d-flex">
          <div class="flex-fill">
            <h1 class="font-weight-bold">{{ Summery.platoon }}</h1>
            <p>قرارگاه</p>
          </div>
          <i
            class="icon-Sheriff-Badge text-primary my-auto"
            style="font-size: 60px"
          ></i>
        </div>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Main",
  computed: {
    ...mapGetters(["Summery", "CurrentUser"]),
  },
  mounted() {
    this.$store.commit("setActivePageHasSubmenu", false);
    document.title = "سامانه شهید باقری";
  },
};
</script>

<style scoped>
.custom-card {
  border-radius: 15px;
  border: thin solid lightseagreen;
}
</style>
